import { render, staticRenderFns } from "./plans-desktop.vue?vue&type=template&id=3d29a185&scoped=true&"
import script from "./plans-desktop.vue?vue&type=script&lang=js&"
export * from "./plans-desktop.vue?vue&type=script&lang=js&"
import style0 from "./plans-desktop.vue?vue&type=style&index=0&id=3d29a185&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d29a185",
  null
  
)

export default component.exports